import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const GO = () => {
  return (
    <StartInterviewLayout type="go"/>
  )
}

export default GO;